// extracted by mini-css-extract-plugin
module.exports = {"tags__inner":"bg_gh","tags":"bg_gj","tags__label":"bg_gk","tags_negative":"bg_gl"};